export class CardTextDto {
  textDetail: string;
  cardInfo: {
    id: string;
  };

  constructor(textDetail: string, id: string) {
    this.textDetail = textDetail;
    this.cardInfo = { id };
  }

}